var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Field__Component" }, [
    _c(
      "div",
      [
        _vm._t("default", function () {
          return [
            _vm.field.Id == "questions"
              ? _c(
                  "a",
                  {
                    style: { textDecoration: "underline" },
                    attrs: {
                      href: `/${_vm.field.RouteName || _vm.field.Id}/${
                        _vm.item.id
                      }`,
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _c("b-icon", {
                      staticStyle: { color: "#337ab7" },
                      attrs: { icon: "cog" },
                    }),
                  ],
                  1
                )
              : _c(
                  "router-link",
                  {
                    style: { textDecoration: "underline" },
                    attrs: {
                      to: `/${_vm.field.RouteName || _vm.field.Id}/${
                        _vm.item.id
                      }`,
                    },
                  },
                  [
                    _c("b-icon", {
                      staticStyle: { color: "#337ab7" },
                      attrs: { icon: "cog" },
                    }),
                  ],
                  1
                ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }